<template>
  <div id="faqComponent" class="align">
    <h2>Часто задаваемые вопросы</h2>
    <faq-part :question="'О сервисе'" :faqVar="1"/>
    <faq-part
      :question="'Это кредит?'"
      :faqVar="2"
      :answer="'Нет, это не кредит. Кредиты могут выдавать только банки. Мы не банк, мы не проверяем кредитную историю и не заключаем кредитный договор с покупателем.'"
    />
    <faq-part
      :question="'Как это работает?'"
      :faqVar="2"
      :answer="'Сервис «kari частями» позволяет разделить сумму вашей покупки на четыре или шесть частей - на ваш выбор. Первая сумма будет списана сразу, а оставшиеся части - по графику. Перед каждым платежом пришлем напоминание о дате списания. Для того, чтобы начать использовать сервис «kari частями» необходимо зарегистрироваться в приложении kari для Android, для iOS, или сделайте покупку на кассе, менеджеры вам помогут.'"
    />
    <faq-part
      :question="'Какие документы нужны для оформления?'"
      :faqVar="2"
      :answer="'Никаких. Для регистрации нам понадобятся только ФИО, дата рождения, телефон, электронная почта.'"
    />
    <faq-part
      :question="'Какие сроки доступны при оплате частями?'"
      :faqVar="3"
      :answer="'При выборе сервиса «kari частями» вы можете выбрать комфортный для вас график:'"
    />
    <faq-part
      :question="'Как узнать дату платежа?'"
      :faqVar="2"
      :answer="'В приложении kari для Android, для iOS, или в своём личном кабинете'"
    />
    <faq-part
      :question="'Как и когда оплачивать?'"
      :faqVar="2"
      :answer="'В приложении kari для Android, для iOS, или в своём личном кабинете есть удобный график платежей, где указана дата и сумма платежа. Платеж мы спишем сами с вашей привязанной карты, вам лишь только нужно не забыть её пополнить к нужной дате, чтобы не допустить штрафа. Перед каждым платежом пришлем напоминание о дате списания. Также вы можете оплатить через СБП или на расчетный счет компании с указанием номера договора.'"
    />
    <faq-part
      :question="'Можно ли оплатить досрочно?'"
      :faqVar="2"
      :answer="'Да, вы можете погасить досрочно всю покупку или только её часть. Но, если вносите досрочно часть от общей суммы покупки, она должна быть не меньше регулярного платежа.'"
    />
    <faq-part
      :question="'Как поменять дату платежа?'"
      :faqVar="2"
      :answer="'Поменять дату платежа можно только в личном кабинете.'"
    />
    <faq-part
      :question="'Как оформить возврат?'"
      :faqVar="2"
      :answer="'Если вдруг вы захотели вернуть всю покупку или только её часть, то необходимо обратиться в магазин и оформить возврат. Мы вернем деньги на вашу карту, точная сумма возврата будет рассчитана исходя из того, сколько и какие платежи вы внесли на момент возврата.'"
    />

    <p>Если у вас остались вопросы — позвоните нам по номеру 8 800 700 90 21</p>

  </div>
</template>

<script>
import FaqPart from '@/components/Parts/faqPart'
export default {
  name: 'faq-component',
  components: { FaqPart }
}
</script>

<style scoped>
#faqComponent>h2 { margin-bottom: 4.27vw }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #faqComponent>h2 { margin-bottom: 40px }
}
</style>
